import { render } from "./WelcomeContractModal.vue?vue&type=template&id=0801067a&scoped=true"
import script from "./WelcomeContractModal.vue?vue&type=script&lang=js"
export * from "./WelcomeContractModal.vue?vue&type=script&lang=js"

import "./WelcomeContractModal.vue?vue&type=style&index=0&id=0801067a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0801067a"]])

export default __exports__